(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37],{

/***/ 48347:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock",
      function () {
        return __webpack_require__(34723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(21470)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(5506)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var _loadable = _interop_require_default(__webpack_require__(14653));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 44305:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(31358)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(56993)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(5506)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var _loadableContext = __webpack_require__(44305);
var useSyncExternalStore = ( true ? __webpack_require__(50959) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ assetNameFormat; },
/* harmony export */   "IT": function() { return /* binding */ stockDetailSymbolFormat; },
/* harmony export */   "bb": function() { return /* binding */ searchSymbolFormat; },
/* harmony export */   "kf": function() { return /* binding */ assetSymbolFormat; },
/* harmony export */   "oR": function() { return /* binding */ stockDetailNameFormat; },
/* harmony export */   "uP": function() { return /* binding */ getCashUnitText; },
/* harmony export */   "xK": function() { return /* binding */ searchNameFormat; }
/* harmony export */ });
/* unused harmony exports HOME_NAME_KR_FORMAT_STOCKS_NATION, HOME_SYMBOL_ALTER_FORMAT_STOCKS_NATION, HOME_NAME_KR_FORMAT_ASSETS, homeNameFormat, NAME_KR_FORMAT_ASSETS, NAME_SYMBOL_ALTER_FORMAT_STOCKS_NATION, TICKER_SYMBOL_FORMAT_STOCKS_NATION, TICKER_SYMBOL_ALTER_FORMAT_STOCKS_NATION, TICKER_SYMBOL_FORMAT_ASSETS, TICKER_NAMEKR_FORMAT_STOCKS_NATION, TICKER_SYMBOL_ALTER_FORMAT_ASSETS, SYMBOL_ALTER_표기_주식_국가, SYMBOL_ALTER_표기_에셋, ASSET_SYMBOL_표기_주식_국가, ASSET_SYMBOL_표기_에셋 */
/* harmony import */ var _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52782);

/**
 * @see https://www.notion.so/weffwd/faba7130cb5c4e978585c312d624f0da#3d573453d64f4135883656bbe4ae3a3c
 */ var getCashUnitText = function(key) {
    return _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .CashUnitMap */ .Wz[key] || _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .CashUnitMap */ .Wz[_dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.KR */ .tR.KR];
};
// [홈 / 분석화면 (수익/비중/배당) ]
var HOME_NAME_KR_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.KR */ .tR.KR,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.CN */ .tR.CN,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.HK */ .tR.HK, 
];
var HOME_SYMBOL_ALTER_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.US */ .tR.US,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.GB */ .tR.GB,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.FR */ .tR.FR,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.DE */ .tR.DE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.NL */ .tR.NL, 
];
var HOME_NAME_KR_FORMAT_ASSETS = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.CRYPTO */ .ou.CRYPTO,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.FUND */ .ou.FUND,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.KR_APT */ .ou.KR_APT, 
];
/**
 * [홈 / 분석화면 (수익/비중/배당) / 종목 상세 (자산 구성)] 의 종목명
 * @param {AssetType} assetClass
 * @param {NationShortType} nation
 * @param {string} nameKr
 * @param {string} symbol
 * @param {string} symbolAlter
 * @returns {string} 표기법에 맞는 문자열
 * @example
 * // returns "TSLA"
 * tickerFormat("STOCK","US","테슬라","TSLA","");
 */ var homeNameFormat = function(assetClass, nation, nameKr, symbol, symbolAlter) {
    if (assetClass === ASSETS.STOCK) {
        if (HOME_NAME_KR_FORMAT_STOCKS_NATION.includes(nation)) {
            return nameKr;
        }
        if (HOME_SYMBOL_ALTER_FORMAT_STOCKS_NATION.includes(nation)) {
            return symbolAlter || symbol;
        }
    }
    if (HOME_NAME_KR_FORMAT_ASSETS.includes(assetClass)) {
        return nameKr;
    }
    return nameKr;
};
// [랭킹 / 검색 / 관심]
var NAME_KR_FORMAT_ASSETS = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.CRYPTO */ .ou.CRYPTO,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.FUND */ .ou.FUND,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.KR_APT */ .ou.KR_APT,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX */ .ou.INDEX,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.COMMODITY */ .ou.COMMODITY,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.EXCHANGE_RATE */ .ou.EXCHANGE_RATE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOLD */ .ou.GOLD,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOV_BONDS */ .ou.GOV_BONDS,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX_FUTURES */ .ou.INDEX_FUTURES,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INTEREST_RATE */ .ou.INTEREST_RATE, 
];
var NAME_SYMBOL_ALTER_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.US */ .tR.US,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.GB */ .tR.GB,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.FR */ .tR.FR,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.DE */ .tR.DE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.NL */ .tR.NL, 
];
/**
 * 랭킹 / 검색 / 관심 리스트의 종목명
 * @param {AssetType} assetClass
 * @param {NationShortType} nation
 * @param {string} nameKr
 * @param {string} nameEn
 * @param {string} symbol
 * @param {string} symbolAlter
 * @returns {string} 표기법에 맞는 문자열
 * @example
 * // returns "TSLA"
 * tickerFormat("STOCK","US","테슬라","Tsla Inc","TSLA","");
 */ var searchNameFormat = function(assetClass, nation, nameKr, nameEn, symbol, symbolAlter) {
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.STOCK */ .ou.STOCK) {
        if (NAME_SYMBOL_ALTER_FORMAT_STOCKS_NATION.includes(nation)) {
            return symbolAlter || symbol;
        }
        return nameKr || nameEn;
    }
    if (NAME_KR_FORMAT_ASSETS.includes(assetClass)) {
        return nameKr;
    }
    return nameKr;
};
var TICKER_SYMBOL_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.KR */ .tR.KR, 
];
var TICKER_SYMBOL_ALTER_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.HK */ .tR.HK,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.CN */ .tR.CN
];
var TICKER_SYMBOL_FORMAT_ASSETS = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.CRYPTO */ .ou.CRYPTO,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX */ .ou.INDEX,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.COMMODITY */ .ou.COMMODITY,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.EXCHANGE_RATE */ .ou.EXCHANGE_RATE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOLD */ .ou.GOLD,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOV_BONDS */ .ou.GOV_BONDS,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX_FUTURES */ .ou.INDEX_FUTURES,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INTEREST_RATE */ .ou.INTEREST_RATE, 
];
var TICKER_NAMEKR_FORMAT_STOCKS_NATION = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.US */ .tR.US,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.GB */ .tR.GB,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.FR */ .tR.FR,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.DE */ .tR.DE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.NL */ .tR.NL, 
];
var TICKER_SYMBOL_ALTER_FORMAT_ASSETS = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.FUND */ .ou.FUND,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.KR_APT */ .ou.KR_APT, 
];
/**
 * 랭킹 / 검색 / 관심 리스트의 티커명
 * @param {AssetType} assetClass
 * @param {NationShortType} nation
 * @param {string} nameKr
 * @param {string} nameEn
 * @param {string} symbol
 * @param {string} symbolAlter
 * @returns {string} 표기법에 맞는 문자열
 * @example
 * // returns "테슬라"
 * tickerFormat("STOCK","US","테슬라","Tsla Inc","TSLA","");
 */ var searchSymbolFormat = function(assetClass, nation, nameKr, nameEn, symbol, symbolAlter) {
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.STOCK */ .ou.STOCK) {
        if (TICKER_SYMBOL_FORMAT_STOCKS_NATION.includes(nation)) {
            return symbol;
        }
        if (TICKER_SYMBOL_ALTER_FORMAT_STOCKS_NATION.includes(nation)) {
            return symbolAlter;
        }
        if (TICKER_NAMEKR_FORMAT_STOCKS_NATION.includes(nation)) {
            return nameKr || nameEn;
        }
    }
    if (TICKER_SYMBOL_FORMAT_ASSETS.includes(assetClass)) {
        return symbol;
    }
    if (TICKER_SYMBOL_ALTER_FORMAT_ASSETS.includes(assetClass)) {
        return symbolAlter;
    }
    return symbol;
};
// [종목 상세]
/**
 * 종목 상세의 종목명
 * @param {string} nameKr
 * @param {string} nameEn
 * @returns {string} 표기법에 맞는 문자열
 * @example
 * // returns "테슬라"
 * tickerFormat("테슬라", "Tsla Inc");
 */ var stockDetailNameFormat = function(nameKr, nameEn) {
    return nameKr || nameEn;
};
var SYMBOL_ALTER_표기_주식_국가 = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.HK */ .tR.HK,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.CN */ .tR.CN,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.US */ .tR.US,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.GB */ .tR.GB,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.FR */ .tR.FR,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.DE */ .tR.DE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.NL */ .tR.NL, 
];
var SYMBOL_ALTER_표기_에셋 = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.CRYPTO */ .ou.CRYPTO,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX */ .ou.INDEX,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.KR_APT */ .ou.KR_APT,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.COMMODITY */ .ou.COMMODITY,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.EXCHANGE_RATE */ .ou.EXCHANGE_RATE,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOLD */ .ou.GOLD,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.GOV_BONDS */ .ou.GOV_BONDS,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX_FUTURES */ .ou.INDEX_FUTURES,
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INTEREST_RATE */ .ou.INTEREST_RATE, 
];
/**
 * 종목 상세의 티커명
 * @param {AssetType} assetClass
 * @param {NationShortType} nation
 * @param {string} symbol
 * @param {string} symbolAlter
 * @returns {string} 표기법에 맞는 문자열
 * @example
 * // returns "TSLA"
 * tickerFormat("STOCK","US","TSLA","");
 */ var stockDetailSymbolFormat = function(assetClass, nation, symbol, symbolAlter) {
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.FUND */ .ou.FUND) return "";
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.INDEX_FUTURES */ .ou.INDEX_FUTURES) {
        return symbolAlter || symbol;
    }
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.STOCK */ .ou.STOCK) {
        if (SYMBOL_ALTER_표기_주식_국가.includes(nation)) return symbolAlter || symbol;
        return symbol;
    }
    if (SYMBOL_ALTER_표기_에셋.includes(assetClass)) {
        return symbolAlter || symbol || "";
    }
    return symbol;
};
// [내 자산]
var assetNameFormat = function(nameKr, nameEn) {
    return nameKr || nameEn;
};
var ASSET_SYMBOL_표기_주식_국가 = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .NATION_SHORT.KR */ .tR.KR, 
];
var ASSET_SYMBOL_표기_에셋 = [
    _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.CRYPTO */ .ou.CRYPTO
];
var assetSymbolFormat = function(assetClass, nation, symbol, symbolAlter) {
    if (assetClass === _dominoapp_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.STOCK */ .ou.STOCK) {
        if (ASSET_SYMBOL_표기_주식_국가.includes(nation)) return symbol;
    }
    if (ASSET_SYMBOL_표기_에셋.includes(assetClass)) return symbol;
    return symbolAlter || symbol;
};


/***/ }),

/***/ 34723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ stock; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.10.6_@types+react@18.0.26_react@18.2.0/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(30654);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@18.2.0_react@18.2.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(9706);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(47588);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/@dominoapp+core-utils@2.0.2_@tanstack+react-query@4.29.1_react-dom@18.2.0_react@18.2.0/node_modules/@dominoapp/core-utils/dist/index.mjs
var dist = __webpack_require__(52782);
// EXTERNAL MODULE: ./src/common/utils/strings/format.ts
var format = __webpack_require__(2353);
;// CONCATENATED MODULE: ./src/domains/Stock/utils/metaTag.ts


var getMetaTagName = function(stockInfoData) {
    var nameKr = stockInfoData.nameKr, nameEn = stockInfoData.nameEn, symbol = stockInfoData.symbol, type = stockInfoData.type, nation = stockInfoData.nation, symbolAlter = stockInfoData.symbolAlter;
    var title = (0,format/* stockDetailNameFormat */.oR)(nameKr, nameEn || "");
    var subTitle = (0,format/* stockDetailSymbolFormat */.IT)(type, nation, symbol, symbolAlter || "");
    return nation === dist/* NATION_SHORT.KR */.tR.KR ? subTitle ? "".concat(title, "(").concat(subTitle, ")") : title : "".concat(subTitle, "(").concat(title, ")");
};
var getMetaTagDescription = function(stockInfoData) {
    var nameKr = stockInfoData.nameKr, nameEn = stockInfoData.nameEn, type = stockInfoData.type;
    var title = (0,format/* stockDetailNameFormat */.oR)(nameKr, nameEn || "");
    switch(type){
        case "STOCK":
            return "".concat(title, "의 장중 실시간 차트 및 프리\xb7애프터 시세를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.");
        case "FUND":
            return "".concat(title, "의 최신 가격 및 차트를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.");
        case "KR_APT":
            return "".concat(title, "의 최근 실거래가를 확인하세요. 보유 자산이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.");
        case "CRYPTO":
            return "".concat(title, "의 장중 실시간 차트를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.");
    }
};

;// CONCATENATED MODULE: ./src/pages/stock/index.tsx





var StockPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(619), __webpack_require__.e(846), __webpack_require__.e(825), __webpack_require__.e(393), __webpack_require__.e(626), __webpack_require__.e(43), __webpack_require__.e(379), __webpack_require__.e(752), __webpack_require__.e(285), __webpack_require__.e(714), __webpack_require__.e(127), __webpack_require__.e(720), __webpack_require__.e(268), __webpack_require__.e(618), __webpack_require__.e(761)]).then(__webpack_require__.bind(__webpack_require__, 43761));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43761)
            ];
        }
    },
    ssr: false
});
var Stock = function(param) {
    var stockInfoData = param.stockInfoData;
    var ogTitle = getMetaTagName(stockInfoData);
    var ogDescription = getMetaTagDescription(stockInfoData);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("title", {
                        children: [
                            ogTitle,
                            " | 올인원 자산관리 도미노"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "description",
                        content: ogDescription
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:site_name",
                        content: "도미노 - 모든 투자를 관리하세요"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:image",
                        content: "".concat(dist/* DOMINO_OG_IMAGE */.eg)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:description",
                        content: ogDescription
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-itunes-app",
                        content: "app-id=1540576519, app-argument=neostock://main"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "icon",
                        href: "https://domino-web-assets.s3.ap-northeast-2.amazonaws.com/web/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StockPage, {
                stockInfoData: stockInfoData
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var stock = (Stock);


/***/ }),

/***/ 9706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17708)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(48347); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);